import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {useDrop} from "react-dnd";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "./RenderByType/RenderComponents";

const BandComponent = ({component, path, index: parentIndex}) => {
    const {onDropComponent, onDropMultipleComponents, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const {styles: sourceStyles, children = []} = component;
    const styles = sourceStyles && sourceStyles.length ? sourceStyles[0] : {};
    const hasChildren = children && children.length;

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.column,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    return (
        <div ref={drop} style={{...styles, height: 'auto'}}>
            {hasChildren ? (
                children.map((item, index) => {
                    return (
                        <RenderComponents
                            key={index}
                            type={item.type}
                            item={item}
                            index={index}
                            path={`${path}.children.${index}`}
                            parentPath={path}
                        />
                    )
                })
            ) : (
                isOverCurrent && (
                    <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                    </div>
                )
            )}
        </div>
    );
};

BandComponent.propTypes = {
    component: PropTypes.object,
    path: PropTypes.string,
    index: PropTypes.number
};

export default BandComponent;